/* eslint-disable no-use-before-define */
/* eslint-disable prettier/prettier */
/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::TsTypes::ConversationsAPITsTypeGenerator`
 * If this file is out-of-sync or causing builds to fail, try running `pay bazel:run //tools/javascript:gen_ts_types`
 */
export type Audience =
  | 'commerce'
  | 'connect'
  | 'connect_onboarding'
  | 'dot_com'
  | 'end_user'
  | 'express'
  | 'internal'
  | 'link'
  | 'onboarding'
  | 'stripe'
  | 'test';

export const Audience_values = [
  'stripe',
  'dot_com',
  'connect',
  'express',
  'link',
  'end_user',
  'onboarding',
  'test',
  'internal',
  'commerce',
  'connect_onboarding',
] as const;

export type ConversationsApiActOnMessagePartEndpointChannelMenuActionData = {
  selected_channel?: string,
};

export type ConversationsApiActOnMessagePartEndpointRequest = {
  data?: Record<string, any>,
};

export type ConversationsApiActOnMessagePartEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiActOnMessagePartEndpointResponseSuccess = {
  type: 'success',
  content?:
    | ConversationsApiDataMessagePartContentTextPartContent
    | ConversationsApiDataMessagePartContentOptionsPartContent
    | ConversationsApiDataMessagePartContentSelectedOptionPartContent
    | ConversationsApiDataMessagePartContentArticlesPartContent
    | ConversationsApiDataMessagePartContentButtonsPartContent
    | ConversationsApiDataMessagePartContentAiResponsePartContent
    | ConversationsApiDataMessagePartContentShowInlineDataPartContent
    | ConversationsApiDataMessagePartContentFollowUpCaseOptionsPartContent
    | ConversationsApiDataMessagePartContentInlineDataOutcomePartContent
    | ConversationsApiDataMessagePartContentChannelMenuPartContent
    | ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContent
    | ConversationsApiDataMessagePartContentFollowUpCaseOptionsSubmissionPartContent
    | ConversationsApiDataMessagePartContentTerminateConversationPartContent
    | ConversationsApiDataMessagePartContentThumbsFeedbackPartContent
    | ConversationsApiDataMessagePartContentAttachmentPartContent
    | ConversationsApiDataMessagePartContentProgressPartContent
    | ConversationsApiDataMessagePartContentSourcesPartContent
    | ConversationsApiDataMessagePartContentCheckoutStudioBuilderFormStatePartContent
    | ConversationsApiDataMessagePartContentCheckoutStudioBuilderStatePartContent,
};

export type ConversationsApiCreateConversationEndpointRequest = {
  audience: Audience,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  refcode?: string,
  forest_version?: string,
  starting_guide?: string,
  preselected_topic?:
    | 'api_integration'
    | 'apms'
    | 'atlas'
    | 'billing'
    | 'capital'
    | 'change_account_info'
    | 'charge_lookup'
    | 'connect'
    | 'corporate_card'
    | 'declines'
    | 'disputes'
    | 'embedded'
    | 'financial_reports'
    | 'getting_started'
    | 'issuing'
    | 'login_issues'
    | 'migrations'
    | 'other'
    | 'payment_apis'
    | 'payouts'
    | 'pci'
    | 'pricing'
    | 'privacy_request'
    | 'radar'
    | 'refunds'
    | 'sigma'
    | 'stripe_apps'
    | 'tax'
    | 'terminal'
    | 'third_party_integrations'
    | 'treasury'
    | 'verification',
  additional_params?: Record<string, string>,
  page_context?: Record<string, any>,
};

export type ConversationsApiCreateConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiCreateConversationEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type ConversationsApiDataConversation = {
  id: string,
  audience: string,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  locale: string,
  owner_id?: string,
  title?: string,
  messages: Array<ConversationsApiDataMessage>,
  participants: Array<ConversationsApiDataParticipant>,
  overview?: ConversationsApiDataConversationOverview,
  temporary_experiment_variant?: string,
};

export type ConversationsApiDataConversationOverview = {
  id: string,
  is_active: boolean,
  last_updated_at: number,
  title?: string,
  live_chat?: ConversationsApiDataConversationOverviewLiveChat,
  request_a_call?: ConversationsApiDataConversationOverviewRequestACall,
  support_ticket_id?: string,
  assistant?: ConversationsApiDataConversationOverviewAssistantThinking,
};

export type ConversationsApiDataConversationOverviewAssistantStatus = 'idle' | 'in_progress';

export const ConversationsApiDataConversationOverviewAssistantStatus_values = [
  'in_progress',
  'idle',
] as const;

export type ConversationsApiDataConversationOverviewAssistantThinking = {
  status: ConversationsApiDataConversationOverviewAssistantStatus,
};

export type ConversationsApiDataConversationOverviewLiveChat = {
  status: 'active' | 'ended',
  external_id: string,
};

export type ConversationsApiDataConversationOverviewRequestACall = {
  status: ConversationsApiDataConversationOverviewRequestACallStatus,
};

export type ConversationsApiDataConversationOverviewRequestACallStatus = 'ended' | 'queued';

export const ConversationsApiDataConversationOverviewRequestACallStatus_values = [
  'queued',
  'ended',
] as const;

export type ConversationsApiDataConversationStatus = 'active' | 'inactive';

export const ConversationsApiDataConversationStatus_values = [
  'active',
  'inactive',
] as const;

export type ConversationsApiDataDynamic = 'active' | 'done' | 'if_latest';

export const ConversationsApiDataDynamic_values = [
  'if_latest',
  'active',
  'done',
] as const;

export type ConversationsApiDataMessage = {
  id: string,
  participant_id: string,
  participant_type: string,
  parts: Array<ConversationsApiDataMessagePart>,
  created: number,
  dynamic?: ConversationsApiDataDynamic,
  creator_part_id?: string,
  in_response_to_id?: string,
  disable_input: boolean,
  allowed_input_modes: Array<string>,
  page_context?: Record<string, string>,
  thumbs_feedback?: 'none' | 'thumbs_down' | 'thumbs_up',
  temporary_experiment_variant?: string,
};

export type ConversationsApiDataMessagePartAiResponse = {
  type: 'ai_response',
  id: number,
  content: ConversationsApiDataMessagePartContentAiResponsePartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartArticles = {
  type: 'articles',
  id: number,
  content: ConversationsApiDataMessagePartContentArticlesPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartAttachment = {
  type: 'attachment',
  id: number,
  content: ConversationsApiDataMessagePartContentAttachmentPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartButtons = {
  type: 'buttons',
  id: number,
  content: ConversationsApiDataMessagePartContentButtonsPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartChannelMenu = {
  type: 'channel_menu',
  id: number,
  content: ConversationsApiDataMessagePartContentChannelMenuPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartChannelMenuSubmission = {
  type: 'channel_menu_submission',
  id: number,
  content: ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartCheckoutStudioBuilderFormState = {
  type: 'checkout_studio_builder_form_state',
  id: number,
  content: ConversationsApiDataMessagePartContentCheckoutStudioBuilderFormStatePartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartCheckoutStudioBuilderState = {
  type: 'checkout_studio_builder_state',
  id: number,
  content: ConversationsApiDataMessagePartContentCheckoutStudioBuilderStatePartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartContentAiResponsePartContent = {
  text: string,
  rendering?: string,
  component_name?: string,
};

export type ConversationsApiDataMessagePartContentArticlesPartContent = {
  text: string,
  article_style?: 'bubble' | 'sources_dropdown',
  articles: Array<ConversationsApiDataMessagePartContentArticlesPartContentArticleItem>,
};

export type ConversationsApiDataMessagePartContentArticlesPartContentArticleItem = {
  cms_article_id?: string,
  title: string,
  url: string,
  collection?:
    | 'express_support_docs'
    | 'link_support_docs'
    | 'stripe_api_docs'
    | 'stripe_docs'
    | 'support_docs'
    | 'support_topic_pages',
};

export type ConversationsApiDataMessagePartContentAttachmentPartContent = {
  text: string,
  name: string,
  size: number,
  attachment_type: string,
  upload_token: string,
};

export type ConversationsApiDataMessagePartContentButtonsPartContent = {
  text: string,
  buttons: Array<ConversationsApiDataMessagePartContentButtonsPartContentButtonItem>,
};

export type ConversationsApiDataMessagePartContentButtonsPartContentButtonItem = {
  title: string,
  url: string,
};

export type ConversationsApiDataMessagePartContentChannelMenuPartContent = {
  text: string,
  channel_options: Array<ConversationsApiDataMessagePartContentChannelMenuPartContentChannelOption>,
  notice?: string,
  notice_type?: string,
  selected_option_id?: string,
  hide_restart_chat_option: boolean,
  show_subject_field: boolean,
  show_unauthenticated_email_field: boolean,
  show_cc_emails_field: boolean,
  initial_name?: string,
  initial_phone_number?: string,
  initial_unauthenticated_email?: string,
  is_rac_form_submitted?: boolean,
  is_email_form_submitted?: boolean,
  error_code?: string,
};

export type ConversationsApiDataMessagePartContentChannelMenuPartContentChannelOption = {
  id: string,
  message: string,
  disabled: boolean,
  icon?: string,
};

export type ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContent = {
  channel: string,
  analytics_event_id?: string,
  rac_form?: ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContentRacForm,
  email_form?: ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContentEmailForm,
  text: string,
};

export type ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContentEmailForm = {
  email: string,
  body: string,
  subject?: string,
  cc_emails?: Array<string>,
  attachment_ids?: Array<string>,
  request_issue_context?: Record<string, any>,
};

export type ConversationsApiDataMessagePartContentChannelMenuSubmissionPartContentRacForm = {
  name: string,
  phone_number: string,
  message: string,
};

export type ConversationsApiDataMessagePartContentCheckoutStudioBuilderFormStatePartContent = {
  text: string,
  form_state: string,
};

export type ConversationsApiDataMessagePartContentCheckoutStudioBuilderStatePartContent = {
  text: string,
  form_state: string,
};

export type ConversationsApiDataMessagePartContentFollowUpCaseOptionsPartContent = {
  text: string,
  options: Array<ConversationsApiDataMessagePartContentFollowUpCaseOptionsPartContentFollowUpCaseOption>,
  show_cc_emails_field: boolean,
  existing_cc_emails?: Array<string>,
  is_email_form_submitted?: boolean,
};

export type ConversationsApiDataMessagePartContentFollowUpCaseOptionsPartContentFollowUpCaseOption = {
  id: string,
  message: string,
};

export type ConversationsApiDataMessagePartContentFollowUpCaseOptionsSubmissionPartContent = {
  channel: string,
  analytics_event_id?: string,
  email_form?: ConversationsApiDataMessagePartContentFollowUpCaseOptionsSubmissionPartContentEmailForm,
  text: string,
};

export type ConversationsApiDataMessagePartContentFollowUpCaseOptionsSubmissionPartContentEmailForm = {
  email: string,
  body: string,
  subject?: string,
  cc_emails?: Array<string>,
  attachment_ids?: Array<string>,
  request_issue_context?: Record<string, any>,
};

export type ConversationsApiDataMessagePartContentInlineDataOutcomePartContent = {
  status: string,
  outcome?: string,
  text: string,
};

export type ConversationsApiDataMessagePartContentOptionsPartContent = {
  text: string,
  options: Array<ConversationsApiDataMessagePartContentOptionsPartContentOptionItem>,
  style?: string,
  recommended_option_id?: string,
  preselected_option_id?: string,
  purpose?: string,
};

export type ConversationsApiDataMessagePartContentOptionsPartContentOptionItem = {
  id: string,
  text: string,
  external_url?: string,
};

export type ConversationsApiDataMessagePartContentProgressPartContent = {
  text: string,
};

export type ConversationsApiDataMessagePartContentSelectedOptionPartContent = {
  id: string,
  text: string,
};

export type ConversationsApiDataMessagePartContentShowInlineDataPartContent = {
  text: string,
  inline_data_name: string,
  rendering: string,
  inline_data_style?: string,
};

export type ConversationsApiDataMessagePartContentSourcesPartContent = {
  text: string,
  sources: Array<ConversationsApiDataMessagePartContentSourcesPartContentSourceItem>,
};

export type ConversationsApiDataMessagePartContentSourcesPartContentSourceItem = {
  title?: string,
  url: string,
  subtitle?: string,
  collection?: string,
  score?: number,
};

export type ConversationsApiDataMessagePartContentTerminateConversationPartContent = {
  reason: string,
  text: string,
  external_chat_id?: string,
};

export type ConversationsApiDataMessagePartContentTextPartContent = {
  text: string,
};

export type ConversationsApiDataMessagePartContentThumbsFeedbackPartContent = {
  text: string,
  feedback_value: string,
  message_id: string,
};

export type ConversationsApiDataMessagePartFollowUpCaseOptions = {
  type: 'follow_up_case_options',
  id: number,
  content: ConversationsApiDataMessagePartContentFollowUpCaseOptionsPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartFollowUpCaseOptionsSubmission = {
  type: 'follow_up_case_options_submission',
  id: number,
  content: ConversationsApiDataMessagePartContentFollowUpCaseOptionsSubmissionPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartInlineDataOutcome = {
  type: 'inline_data_outcome',
  id: number,
  content: ConversationsApiDataMessagePartContentInlineDataOutcomePartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartOptions = {
  type: 'options',
  id: number,
  content: ConversationsApiDataMessagePartContentOptionsPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartProgress = {
  type: 'progress',
  id: number,
  content: ConversationsApiDataMessagePartContentProgressPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartSelectedOption = {
  type: 'selected_option',
  id: number,
  content: ConversationsApiDataMessagePartContentSelectedOptionPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartShowInlineData = {
  type: 'show_inline_data',
  id: number,
  content: ConversationsApiDataMessagePartContentShowInlineDataPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartSources = {
  type: 'sources',
  id: number,
  content: ConversationsApiDataMessagePartContentSourcesPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartTerminateConversation = {
  type: 'terminate_conversation',
  id: number,
  content: ConversationsApiDataMessagePartContentTerminateConversationPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartText = {
  type: 'text',
  id: number,
  content: ConversationsApiDataMessagePartContentTextPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartThumbsFeedback = {
  type: 'thumbs_feedback',
  id: number,
  content: ConversationsApiDataMessagePartContentThumbsFeedbackPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataParticipant = {
  id: string,
  merchant_id?: string,
  type:
    | 'assistant'
    | 'human_agent'
    | 'system'
    | 'user',
  display_name?: string,
};

export type ConversationsApiDeleteConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiDeleteConversationEndpointResponseSuccess = {
  type: 'success',
  id: string,
  deleted: boolean,
};

export type ConversationsApiEndConversationEndpointResponseConflict = {
  type: 'conflict',
  error: string,
};

export type ConversationsApiEndConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiEndConversationEndpointResponseInvalidState = {
  type: 'invalid_state',
  error: string,
};

export type ConversationsApiEndConversationEndpointResponseSuccess = {
  type: 'success',
  id: string,
  assistant_conversation_ended: boolean,
  live_chat_ended: boolean,
  request_a_call_canceled: boolean,
};

export type ConversationsApiListConversationsEndpointRequest = {
  audience: Audience,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  status?: ConversationsApiDataConversationStatus,
  limit?: number,
  conversation_ids?: Array<string>,
};

export type ConversationsApiListConversationsEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiListConversationsEndpointResponseSuccess = {
  type: 'success',
  conversations: Array<ConversationsApiDataConversationOverview>,
};

export type ConversationsApiPollConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiPollConversationEndpointResponseSuccess = {
  type: 'success',
  messages: Array<ConversationsApiDataMessage>,
};

export type ConversationsApiRetrieveConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiRetrieveConversationEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type ConversationsApiSendMessageEndpointRequest = {
  id?: string,
  participant_id: string,
  participant_type: string,
  parts: Array<ConversationsApiDataMessagePart>,
  creator_part_id?: string,
  data_with_pii?: Record<string, any>,
  page_context?: Record<string, any>,
};

export type ConversationsApiSendMessageEndpointResponseError = {
  type: 'error',
  error: string,
  error_code?: string,
  message?: ConversationsApiDataMessage,
};

export type ConversationsApiSendMessageEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type SupportEntryPointEntryPoint =
  | 'commerce_home'
  | 'connect_hosted_onboarding'
  | 'dashboard'
  | 'dashboard_feedback'
  | 'dot_com'
  | 'dot_com_embedded_csf'
  | 'embedded_connect_support_site'
  | 'end_user_support_site'
  | 'express_dashboard'
  | 'express_support_site'
  | 'front'
  | 'inbound_call'
  | 'inbound_email'
  | 'internal_admin'
  | 'issuing_support'
  | 'link_support_site'
  | 'mobile_android'
  | 'mobile_ios'
  | 'mobile_link_android'
  | 'mobile_link_ios'
  | 'native_mobile_ios'
  | 'onboarding'
  | 'platform_support_site'
  | 'react_native_mobile_android'
  | 'react_native_mobile_ios'
  | 'slack'
  | 'support_site'
  | 'wechat';

export const SupportEntryPointEntryPoint_values = [
  'support_site',
  'dot_com',
  'dot_com_embedded_csf',
  'dashboard',
  'mobile_ios',
  'native_mobile_ios',
  'mobile_android',
  'react_native_mobile_ios',
  'react_native_mobile_android',
  'mobile_link_ios',
  'mobile_link_android',
  'express_dashboard',
  'express_support_site',
  'link_support_site',
  'end_user_support_site',
  'embedded_connect_support_site',
  'platform_support_site',
  'dashboard_feedback',
  'front',
  'inbound_call',
  'inbound_email',
  'slack',
  'onboarding',
  'issuing_support',
  'internal_admin',
  'commerce_home',
  'connect_hosted_onboarding',
  'wechat',
] as const;

export type SupportTriggerPointTriggerPoint =
  | 'account_status_home_call_to_action'
  | 'account_status_task_details_call_to_action'
  | 'assistant_drawer_internal'
  | 'assistant_new_conversation'
  | 'assistant_onboarding'
  | 'assistant_search_result_direct'
  | 'assistant_search_result_suggested_query'
  | 'commerce_home_main'
  | 'connect_hosted_onboarding_help_button'
  | 'dashboard_checkout_studio_builder'
  | 'dashboard_checkout_studio_builder_greeting_message'
  | 'dashboard_checkout_studio_inspect'
  | 'dashboard_help_icon'
  | 'dashboard_help_menu_contact_support'
  | 'dashboard_mobile_ios_app_get_help'
  | 'dashboard_mobile_ios_assistant'
  | 'dashboard_search_ai'
  | 'dashboard_support_center_case_detail_page'
  | 'dashboard_support_center_home'
  | 'dot_com_chat_button'
  | 'dot_com_chat_button_with_llm'
  | 'dot_com_console'
  | 'dot_com_embedded_csf'
  | 'dot_com_embedded_csf_self_serve'
  | 'dot_com_pricing_choose_pathway'
  | 'internal_admin'
  | 'internal_os_bot_channel'
  | 'internal_os_bot_dm'
  | 'link_mobile_get_support'
  | 'link_support_site_purchase_help_card'
  | 'payments_analytics'
  | 'question_helpfulness_sorry_message'
  | 'react_native_mobile_get_help'
  | 'reports_hub_assistant_cta'
  | 'support_site_article_page_assistant'
  | 'support_site_contact_support_link'
  | 'support_site_contact_url'
  | 'support_site_contact_us_link'
  | 'support_site_content'
  | 'support_site_home_page_assistant'
  | 'support_site_i_cant_sign_in'
  | 'terminal_shop_assistant_cta'
  | 'unspecified';

export const SupportTriggerPointTriggerPoint_values = [
  'dashboard_help_menu_contact_support',
  'dashboard_help_icon',
  'assistant_search_result_direct',
  'assistant_drawer_internal',
  'assistant_new_conversation',
  'dashboard_support_center_home',
  'react_native_mobile_get_help',
  'dashboard_mobile_ios_app_get_help',
  'link_mobile_get_support',
  'dashboard_mobile_ios_assistant',
  'support_site_contact_url',
  'support_site_contact_support_link',
  'support_site_i_cant_sign_in',
  'question_helpfulness_sorry_message',
  'support_site_content',
  'support_site_home_page_assistant',
  'link_support_site_purchase_help_card',
  'support_site_article_page_assistant',
  'dot_com_chat_button',
  'dot_com_embedded_csf',
  'dot_com_embedded_csf_self_serve',
  'dot_com_pricing_choose_pathway',
  'dashboard_search_ai',
  'dashboard_checkout_studio_builder',
  'dashboard_checkout_studio_builder_greeting_message',
  'dashboard_checkout_studio_inspect',
  'payments_analytics',
  'reports_hub_assistant_cta',
  'terminal_shop_assistant_cta',
  'unspecified',
  'internal_admin',
  'account_status_home_call_to_action',
  'account_status_task_details_call_to_action',
  'commerce_home_main',
  'connect_hosted_onboarding_help_button',
  'internal_os_bot_dm',
  'internal_os_bot_channel',
  'dot_com_chat_button_with_llm',
  'dot_com_console',
  'dashboard_support_center_case_detail_page',
  'assistant_onboarding',
  'assistant_search_result_suggested_query',
  'support_site_contact_us_link',
] as const;

export type UniversalHelpPrivateDocumentMessagePartMessagePartType =
  | 'ai_response'
  | 'articles'
  | 'attachment'
  | 'buttons'
  | 'channel_menu'
  | 'channel_menu_submission'
  | 'checkout_studio_builder_form_state'
  | 'checkout_studio_builder_state'
  | 'follow_up_case_options'
  | 'follow_up_case_options_submission'
  | 'inline_data_outcome'
  | 'options'
  | 'progress'
  | 'selected_option'
  | 'show_inline_data'
  | 'sources'
  | 'terminate_conversation'
  | 'text'
  | 'thumbs_feedback';

export const UniversalHelpPrivateDocumentMessagePartMessagePartType_values = [
  'text',
  'options',
  'selected_option',
  'articles',
  'buttons',
  'ai_response',
  'show_inline_data',
  'inline_data_outcome',
  'channel_menu',
  'channel_menu_submission',
  'follow_up_case_options',
  'follow_up_case_options_submission',
  'terminate_conversation',
  'thumbs_feedback',
  'attachment',
  'progress',
  'sources',
  'checkout_studio_builder_form_state',
  'checkout_studio_builder_state',
] as const;

export type ConversationsApiActOnMessagePartEndpointResponse = ConversationsApiActOnMessagePartEndpointResponseError | ConversationsApiActOnMessagePartEndpointResponseSuccess;

export type ConversationsApiCreateConversationEndpointResponse = ConversationsApiCreateConversationEndpointResponseError | ConversationsApiCreateConversationEndpointResponseSuccess;

export type ConversationsApiDataMessagePart =
  | ConversationsApiDataMessagePartAiResponse
  | ConversationsApiDataMessagePartArticles
  | ConversationsApiDataMessagePartAttachment
  | ConversationsApiDataMessagePartButtons
  | ConversationsApiDataMessagePartChannelMenu
  | ConversationsApiDataMessagePartChannelMenuSubmission
  | ConversationsApiDataMessagePartCheckoutStudioBuilderFormState
  | ConversationsApiDataMessagePartCheckoutStudioBuilderState
  | ConversationsApiDataMessagePartFollowUpCaseOptions
  | ConversationsApiDataMessagePartFollowUpCaseOptionsSubmission
  | ConversationsApiDataMessagePartInlineDataOutcome
  | ConversationsApiDataMessagePartOptions
  | ConversationsApiDataMessagePartProgress
  | ConversationsApiDataMessagePartSelectedOption
  | ConversationsApiDataMessagePartShowInlineData
  | ConversationsApiDataMessagePartSources
  | ConversationsApiDataMessagePartTerminateConversation
  | ConversationsApiDataMessagePartText
  | ConversationsApiDataMessagePartThumbsFeedback;

export type ConversationsApiDeleteConversationEndpointResponse = ConversationsApiDeleteConversationEndpointResponseError | ConversationsApiDeleteConversationEndpointResponseSuccess;

export type ConversationsApiEndConversationEndpointResponse =
  | ConversationsApiEndConversationEndpointResponseConflict
  | ConversationsApiEndConversationEndpointResponseError
  | ConversationsApiEndConversationEndpointResponseInvalidState
  | ConversationsApiEndConversationEndpointResponseSuccess;

export type ConversationsApiListConversationsEndpointResponse = ConversationsApiListConversationsEndpointResponseError | ConversationsApiListConversationsEndpointResponseSuccess;

export type ConversationsApiPollConversationEndpointResponse = ConversationsApiPollConversationEndpointResponseError | ConversationsApiPollConversationEndpointResponseSuccess;

export type ConversationsApiRetrieveConversationEndpointResponse = ConversationsApiRetrieveConversationEndpointResponseError | ConversationsApiRetrieveConversationEndpointResponseSuccess;

export type ConversationsApiSendMessageEndpointResponse = ConversationsApiSendMessageEndpointResponseError | ConversationsApiSendMessageEndpointResponseSuccess;
